import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramArrow } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramArrow';
import { DiagramBox } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBox';
import { DiagramStop } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramStop';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { BoxTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/BoxTone';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const WaterfallDiagram = () => (
  <Diagram viewBox="0 0 340 120">
    <DiagramText x={215} y={20} tone={TextTone.MUTED} small tId="IN_RANKING_ORDER" />
    <DiagramBox x={8} y={45} width={70} height={30} tone={BoxTone.REQUEST} />
    <DiagramText x={43} y={64} tone={TextTone.INVERSE} bold tId="REQUEST" />
    <DiagramArrow d="M78,60 L96,60" />
    <DiagramBox x={98} y={47} width={66} tone={BoxTone.NO} />
    <DiagramText x={131} y={64}>
      1º A
    </DiagramText>
    <DiagramText x={131} y={89} tone={TextTone.NO} small tId="REJECTS" />
    <DiagramArrow d="M164,60 L182,60" />
    <DiagramBox x={184} y={47} width={66} tone={BoxTone.YES} />
    <DiagramText x={217} y={64}>
      2º C
    </DiagramText>
    <DiagramText x={217} y={89} tone={TextTone.YES} small bold tId="APPROVES" />
    <DiagramStop x={258} y={43} />
    <DiagramBox x={270} y={47} width={62} tone={BoxTone.GHOST} />
    <DiagramText x={301} y={64} tone={TextTone.GHOST}>
      3º B
    </DiagramText>
    <DiagramText x={301} y={89} tone={TextTone.MUTED} small tId="NOT_CONSULTED" />
  </Diagram>
);
